module.exports = __webpack_public_path__ + "img/lock3.d57a9d3b.png";